import $axios from '../services/apiLms.js'

const state = () => ({
    data: [],
    detail: {},
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.data = payload
    },
    ASSIGN_DETAIL(state, payload) {
        state.detail = payload
    },
}

const actions = {
    getAllSettingMobile({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`setting-mobile`)
                .then((response) => {
                    commit('ASSIGN_DATA', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getByKeySettingMobile({ commit }, key) {
        return new Promise((resolve) => {
            $axios.get(`setting-mobile/${key}`)
                .then((response) => {
                    commit('ASSIGN_DETAIL', response.data.data)
                    resolve(response.data)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
